(function() {
  const config = window.WholesaleConfig || {
    isLoggedIn: false,
    hasWholesaleTag: false,
    selectors: {
      addToCart: '',
      prices: '', 
      loginOnlyBlocks: '',
      quantity: ''
    },
    messages: {
      loginToView: 'Log in to view prices',
      wholesaleOnly: 'Wholesale account required to purchase'
    }
  };

  let domObserver = null;

  function injectStyles(styles) {
    const el = document.createElement("style");
    el.innerText = styles;
    document.head.appendChild(el);
  }

  function hideElements(selector) {
    if (!selector) return;
    document.querySelectorAll(selector).forEach(el => {
      if (el.style.display !== 'none') {
        el.style.display = 'none';
        el.style.visibility = 'hidden';
      }
    });
  }

  function maskPrices(selector, message) {
    if (!selector) return;
    document.querySelectorAll(selector).forEach(el => {
      // Using textContent handles hidden elements much more reliably than innerText
      if (el.textContent.trim() !== message) {
        el.textContent = message;
        el.style.visibility = 'visible'; 
        el.style.display = 'inline-block'; // Forces it to render properly if the theme altered it
      }
    });
  }

  function disableElements(selector, message) {
    if (!selector) return;
    document.querySelectorAll(selector).forEach(el => {
      if (el.disabled) return;

      el.disabled = true;
      el.style.opacity = '0.5';
      el.style.cursor = 'not-allowed';

      if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
        if (el.tagName === 'INPUT' && el.value !== message) el.value = message;
        else if (el.textContent.trim() !== message) el.textContent = message;
      }
    });
  }

  function applyRestrictions() {
    if (domObserver) domObserver.disconnect();

    const hasAccess = config.isLoggedIn && config.hasWholesaleTag;

    if (!hasAccess) {
      hideElements(config.selectors.loginOnlyBlocks);
      hideElements(config.selectors.quantity);
      maskPrices(config.selectors.prices, config.messages.loginToView);
      disableElements(config.selectors.addToCart, config.messages.loginToView);
    }

    if (domObserver) {
      domObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true // Also watches for theme currency scripts trying to change text back
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    domObserver = new MutationObserver(applyRestrictions);
    applyRestrictions();
  });

  const hasAccess = config.isLoggedIn && config.hasWholesaleTag;
  if (!hasAccess) {
    const s = config.selectors;
    let cssStyles = '';

    const elementsToHide = [s.loginOnlyBlocks, s.quantity].filter(Boolean).join(', ');
    if (elementsToHide) {
      cssStyles += `${elementsToHide} { display: none !important; } \n`;
    }

    if (s.prices) {
      // Keep it hidden initially until our JS safely overwrites the text
      cssStyles += `${s.prices} { visibility: hidden !important; } \n`;
    }

    if (cssStyles) {
      injectStyles(cssStyles);
    }
  }
})();